module.exports = __webpack_public_path__ + "static/media/mpeg-icon.eb31df5c.svg";